import { render, staticRenderFns } from "./multiple-add.vue?vue&type=template&id=36d51da1&scoped=true"
import script from "./multiple-add.vue?vue&type=script&lang=js"
export * from "./multiple-add.vue?vue&type=script&lang=js"
import style0 from "./multiple-add.vue?vue&type=style&index=0&id=36d51da1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d51da1",
  null
  
)

export default component.exports